/**
 * TA-1370 F-02 (Apple HIG review 2026-10-26): the one class for a text input,
 * select or textarea. Its edge is --color-border-control, 3:1 or more against
 * every surface a field sits on in both themes (tokens.css), where the old
 * --color-border hairline was 1.2:1 and a field read as a grey patch. One
 * radius (md) and one fill (surface-subtle) for every field.
 *
 * No outline or focus classes: the unlayered :focus-visible rule in
 * globals.css is the focus ring (F-10). Layout (width, margins, resize) stays
 * at the call site; merge a different padding or size through cn().
 * classLint.test.ts refuses a field in src that does not reach this class.
 */
export const FIELD_CLASS =
  "rounded-[var(--radius-md)] border border-[var(--color-border-control)] bg-[var(--color-surface-subtle)] " +
  "min-h-9 px-3 py-1.5 text-[length:var(--text-sm)] text-[var(--color-ink)]";
